
(() => {
  const colorSwitcherSelector = '[js-cus-color-swatch]';

  document.addEventListener('click', function(e){
    document.querySelectorAll(colorSwitcherSelector).forEach(function ($swatch) {

      if($swatch.contains(e.target)){
        const productTitle = $swatch.dataset.productTitle;
        const productPrice = $swatch.dataset.productPrice;
        const productComparePrice = $swatch.dataset.productComparePrice;
        const productComparePriceNumber = Number(productComparePrice.replace('$', ''));
        const productImage = $swatch.dataset.productImage;
        const productHoverImage = $swatch.dataset.productHoverImage;
        const producUrl = $swatch.dataset.productUrl;
        const item = $swatch.closest("[js-cus-product]");
        item.querySelector('[js-product-title]').innerHTML = productTitle;
        item.querySelector('[js-product-price]').innerHTML = productPrice;
        item.querySelector('[js-product-compare-price]').innerHTML = productComparePriceNumber > 0
          ? productComparePrice
          : '';

        const jsCusImage = item.querySelector('[js-cus-image]');
        if (jsCusImage.classList.contains('lazyautosizes')) {
          jsCusImage.removeAttribute('data-srcset');
          jsCusImage.removeAttribute('srcset');
        }
        jsCusImage.setAttribute('src', productImage);

        const jsCusHoverImage = item.querySelector('[js-cus-hover-image]');
        if (jsCusHoverImage.classList.contains('lazyautosizes')) {
          jsCusHoverImage.removeAttribute('data-srcset');
          jsCusHoverImage.removeAttribute('srcset');
        }
        jsCusHoverImage.setAttribute('src', productHoverImage);
    
        item.querySelectorAll('[js-product-url]').forEach(productAnchor => {
          productAnchor.setAttribute('href', producUrl);
        });
        item.querySelectorAll(colorSwitcherSelector).forEach(colorSwitch => {
            colorSwitch.classList.remove('active');
        });
        $swatch.classList.add('active');
      }
    })
  });
})()